import { queryClient } from "~/plugins/vue-query";
import { projectService } from "~/utils/api/projectService";
import { notificationsService } from "@/utils/api/notificationsService";
import { settlementsService } from "~/utils/api/settlementsService";
import { getProjectId } from "~/utils/getProjectId";

export default defineNuxtRouteMiddleware(async () => {
  queryClient.fetchQuery({
    queryKey: ["projects"],
    queryFn: () =>
      projectService.getProject({
        with: ["advisor", "engineer", "project"],
      }),
  });
  queryClient.fetchQuery({
    queryKey: ["notifications"],
    queryFn: () =>
      notificationsService.getNotifications({
        per_page: 6,
        order_by: "read_at",
      }),
  });

  const projectId = getProjectId();

  if (projectId) {
    queryClient.fetchQuery({
      queryKey: ["settlements-stages"],
      queryFn: () =>
        settlementsService.getSettlementStages({
          client_project_id: projectId,
          with: ["settlements", "settlements.payments"],
          order_direction: "asc",
        }),
    });
  }
});
